import { render, staticRenderFns } from "./searchView.vue?vue&type=template&id=a1b632e8&scoped=true&"
import script from "./searchView.vue?vue&type=script&lang=js&"
export * from "./searchView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b632e8",
  null
  
)

export default component.exports